/**
 * Centralized TTS Model Configuration
 * This file contains the default model configuration that should be used throughout the application.
 * When the model changes, update it here only.
 * 
 * NOTE: This should match the backend configuration in django_backend/tts_submit_job/model_config.py
 */

// Default TTS Model Configuration
//
// Creole Studio is the default. Slight French accent lean but
// dramatically better prosody than the VITS-based ccl_ht_v100. Users
// who want authentic regional Haitian accents pick voices from the
// "Creole Regional" group — voice groups route off
// `supported_models`, so nothing here forces one model over another.
//
// Do NOT leak the upstream vendor name in displayName/description —
// these strings surface to end users via the model picker.
export const DEFAULT_TTS_MODEL = {
  id: 'ccl_ht_gem',
  name: 'Creole Studio',
  displayName: 'Creole Studio',
  description: 'Haitian Creole TTS with high-fidelity prosody',
  version: '3.1',
};

// Convenience exports
export const DEFAULT_MODEL_ID = DEFAULT_TTS_MODEL.id;
export const DEFAULT_MODEL_NAME = DEFAULT_TTS_MODEL.name;
export const DEFAULT_MODEL_DISPLAY_NAME = DEFAULT_TTS_MODEL.displayName;